import * as React from 'react';
import { Button } from '@/components/ui/Button';
import { GradientModal } from '@/components/ui/GradientModal';
import { useUiStore } from '@/store/uiStore';
import { useDeleteCreatorProfile } from '@/hooks/useDeleteCreatorProfile';

// Shared Components
import { DeleteModalHeader } from './shared/DeleteModalHeader';
import { GracePeriodCard } from './shared/GracePeriodCard';
import { DeleteWarningList } from './shared/DeleteWarningList';

// Assets
import deleteCreatorIcon from '@/assets/images/svg/delete_creator_profile.svg';

export const DeleteCreatorModal: React.FC = () => {
  const isOpen = useUiStore((state) => state.modals.deleteCreator);
  const closeModal = useUiStore((state) => state.closeModal);
  const { deleteCreatorProfile, isDeleting } = useDeleteCreatorProfile();

  const warningItems = [
    'Your digital echo will be immediately deactivated and hidden from fans',
    'All active subscriptions will be cancelled at the end of the current billing period',
    'Your earnings will remain accessible and can be withdrawn at any time',
    'Fans will no longer be able to interact with your digital echo',
    'After 30 days, your personality configuration and all conversation history will be permanently deleted',
  ];

  const handleConfirm = async () => {
    await deleteCreatorProfile();
    closeModal('deleteCreator');
  };

  return (
    <GradientModal isOpen={isOpen} onClose={() => closeModal('deleteCreator')} variant='gray'>
      <DeleteModalHeader
        icon={deleteCreatorIcon}
        title='Delete Creator Profile'
        subtitle='Are you sure you want to cancel your creator profile?'
        description='This action will affect your account and digital echo.'
      />

      <GracePeriodCard />

      <DeleteWarningList items={warningItems} />

      <div className='mt-8 flex w-full flex-col items-center gap-4 md:flex-row md:justify-between'>
        <Button
          type='button'
          onClick={() => closeModal('deleteCreator')}
          variant='settings-modify'
          className='h-[44px] w-full px-8 text-16 text-brand-800 md:w-auto'
        >
          Keep My Creator Profile
        </Button>

        <Button
          onClick={handleConfirm}
          disabled={isDeleting}
          variant='text-destructive'
          size='auto'
          className='md:ml-auto'
        >
          {isDeleting ? 'DELETING...' : 'DELETE'}
        </Button>
      </div>
    </GradientModal>
  );
};
